import { Row, Table } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { setModal } from '../../../../common/slices/commonSlice';
import { crud, perProps } from '../../../../common/types/commonTypes';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import CommonTableHeader from '../../../../components/common/CommonTableHeader';
import LoadingIndicator, {
  loadingIndicator,
} from '../../../../components/common/spinner/LoadingIndicator';
import { useGetAllDepartmentsWithPaginationQuery } from '../endpoints/departmentEndpoints';
import DepartmentsAddModal from '../modals/DepartmentsAddModal';
import DepartmentsEditModal from '../modals/DepartmentsEditModal';
import { DepartmentDataType } from '../types/departmentTypes';
import { columns } from '../utils/utils';

const Departments = ({ permission }: perProps) => {
  const dispatch = useAppDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
  });

  const handlePaginationChange = (current: number, pageSize: number) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current,
      pageSize,
    }));
  };

  const [editInfo, setEditInfo] = useState<DepartmentDataType | null>(null);

  const showModal = () => {
    dispatch(setModal(true));
  };

  const {
    isLoading,
    data: department,
    refetch,
  } = useGetAllDepartmentsWithPaginationQuery(pagination, {
    selectFromResult: (cache) => {
      const data = cache.data?.data;
      const count = cache.data?.count;
      const dataToReturn: DepartmentDataType[] = [];
      const departmentNameList: string[] = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          departmentNameList.push(element.department_name);
          dataToReturn.push({
            ...element,
            key: i + 1,
          });
        }
      }
      return { ...cache, data: { dataToReturn, departmentNameList, count } };
    },
  });

  return (
    <div>
      <BreadCrumb
        arrOfOption={['Configuration', 'Departments']}
        refetch={refetch}
        reloaderSize='small'
      />
      <CommonTableHeader
        width
        align
        modalTitle={editInfo ? 'Edit Department' : 'Add New Department'}
        title='Departments'
        button_text='Add New Department'
        permission={permission?.[crud.create]}
        element={
          editInfo ? (
            <DepartmentsEditModal
              info={editInfo}
              setNull={setEditInfo}
              department={department.departmentNameList}
            />
          ) : (
            <DepartmentsAddModal department={department.departmentNameList} />
          )
        }
        setNull={setEditInfo}
      />
      <Row justify={'center'}>
        <Table
          size='small'
          style={{ width: 900 }}
          bordered
          pagination={
            department?.count !== undefined && department?.count < 20
              ? false
              : {
                ...pagination,
                total: department?.count,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '200', '500'],
                onChange: handlePaginationChange,
              }
          }
          columns={columns({ setEditInfo, showModal, permission, pagination })}
          dataSource={department.dataToReturn}
          scroll={{ x: true }}
          loading={{ spinning: isLoading, indicator: loadingIndicator }}
        />
      </Row>
      {isLoading && <LoadingIndicator />}
    </div>
  );
};

export default Departments;
